import HotelBoxV2 from '../HotelBoxV2';

const HotelLoading = () => {
  return (
    <HotelBoxV2>
      <div className="flex overflow-hidden w-full flex-row gap-4 pb-1 lg:grid grid-cols-4 ps-4 sm:ps-0">
        <div className="h-full  w-full  last:pe-4 last:md:pe-0 ">
          <div className="flex w-full flex-col rounded-xl overflow-hidden lg:rounded-xl bg-white p-0 shadow-sm  ">
            <div
              className="relative bg-slate-100 animate-pulse aspect-[0.96/1] md:aspect-[0.96/1] w-full overflow-hidden "
            >

            </div>

          </div>
        </div>
        <div className="h-full  w-full  last:pe-4 last:md:pe-0 ">
          <div className="flex w-full flex-col rounded-xl overflow-hidden lg:rounded-xl bg-white p-0 shadow-sm  ">
            <div
              className="relative bg-slate-100 animate-pulse aspect-[0.96/1] md:aspect-[0.96/1] w-full overflow-hidden "
            >

            </div>

          </div>
        </div>
        <div className="h-full  w-full  last:pe-4 last:md:pe-0 ">
          <div className="flex w-full flex-col rounded-xl overflow-hidden lg:rounded-xl bg-white p-0 shadow-sm  ">
            <div
              className="relative bg-slate-100 animate-pulse aspect-[0.96/1] md:aspect-[0.96/1] w-full overflow-hidden "
            >

            </div>

          </div>
        </div>
        <div className="h-full  w-full  last:pe-4 last:md:pe-0 ">
          <div className="flex w-full flex-col rounded-xl overflow-hidden lg:rounded-xl bg-white p-0 shadow-sm  ">
            <div
              className="relative bg-slate-100 animate-pulse aspect-[0.96/1] md:aspect-[0.96/1] w-full overflow-hidden "
            >

            </div>

          </div>
        </div>
      </div>
    </HotelBoxV2>
  );
};
export default HotelLoading;
